import { render, staticRenderFns } from "./kpagecontainer.vue?vue&type=template&id=4b1c645c&scoped=true&"
import script from "./kpagecontainer.vue?vue&type=script&lang=js&"
export * from "./kpagecontainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c645c",
  null
  
)

export default component.exports